import { Avatar, Box, Button, SxProps, Tooltip, Typography } from "@mui/material"
import { colors } from "../../../constants/colors";
import SwiperCustom from "../../../components/swiper/SwiperCustom";
import { thaiMonths } from "../../../utils/monthThai";
import moment from "moment";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link } from "react-router-dom";
import { PollVoteCard } from "../poll-vote/element/element";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { lstat } from "fs";


type activityCardProps = {
    sx?: SxProps;
    title: string;
    detail: string;
    data_slide: { img_url: string, id: number, url: string, current_tab?: boolean }[];
    activity_data: { to: string, start_date: string | Date, title: string, detail: string, position: string, start_time: string, end_time: string }[];
    onViewAllClick?: () => void;
}
export const ActivityCard: React.FC<activityCardProps> = ({ activity_data, sx, title, detail, onViewAllClick, data_slide }) => {
    return (
        <Box sx={sx} className="grid grid-cols-12 gap-4">
            <Box className="flex flex-col justify-between gap-10 col-span-12 md:col-span-6 xl:col-span-8">
                <span className="flex flex-col gap-4">
                    <Typography fontWeight={700} fontSize={{ xs: "20px", md: "24px" }}>{title}</Typography>
                    <Typography>{detail}</Typography>
                </span>
                <span className="w-full h-full overflow-hidden max-h-full min-h-[392px]">
                    <SwiperCustom
                        data={data_slide?.map((list, index) => {
                            return {
                                content: (
                                    <Link to={list.url} target={list.current_tab ? undefined : '_blank'}>
                                        <Box className="w-full h-full" key={`${list?.id}_${index}`} >
                                            <img className="w-full object-contain" src={list?.img_url} />
                                        </Box>
                                    </Link>
                                )
                            }
                        })}
                    />
                </span>
            </Box >
            <Box className="flex flex-col gap-2 col-span-12 md:col-span-6 xl:col-span-4">
                <span className="flex justify-end items-center">
                    <Button sx={{ color: colors.themeMainColorTwo }} onClick={onViewAllClick}>ดูกิจกรรมทั้งหมด</Button>
                </span>
                <span className="flex flex-col gap-6">
                    {activity_data?.map((list, i) => {
                        const month_num = moment(list?.start_date).month();
                        const day_num = moment(list?.start_date).date();
                        const month_name_th = thaiMonths?.find((_, i) => i == month_num) || "-";
                        return (
                            <Box className="flex gap-8" key={i}>
                                <Box className="w-full gap-2 rounded-[16px] flex justify-center items-center flex-col max-w-[114px] border-2 border-[#CFA56D]">
                                    <Typography sx={{ fontSize: "36px" }} fontWeight={700}>{day_num}</Typography>
                                    <Typography>{month_name_th}</Typography>
                                </Box>
                                <Box className="flex flex-col gap-2">
                                    <Link className="hover:underline" to={list?.to}>
                                        <Typography>
                                            {list?.title || "-"}
                                        </Typography>
                                    </Link>
                                    <Typography sx={{ color: '#828282' }}>
                                        ประเภทกิจกรรม : {list?.detail || "-"}
                                    </Typography>
                                    {/* <Box className="flex justify-start items-center gap-2">
                                        <LocationOnIcon />
                                        <Typography>
                                            {list?.position}
                                        </Typography>
                                    </Box> */}
                                    <Box className="flex gap-4">
                                        <span className="flex gap-2 justify-start items-center">
                                            <CalendarMonthIcon />
                                            <Typography>{moment(list?.start_date)?.format("DD/MM/YY")}</Typography>
                                        </span>
                                        <span className="flex justify-start items-center gap-2">
                                            <WatchLaterIcon />
                                            <Typography>
                                                {list?.start_time} - {list?.end_time}
                                            </Typography>
                                        </span>
                                    </Box>
                                </Box>
                            </Box>
                        )
                    })}
                </span>
            </Box>
        </Box >
    )
}



type pollVoteCardProps = {
    data: any[];
    handleSendForm?: (id_form_poll: number, id_form_poll_choice: number, auth_required: boolean) => void;
    handleChangeFormPoll?: (id_form_poll: number, id_form_poll_choice: number) => void;
}

export const PollVoteCardWebsite: React.FC<pollVoteCardProps> = ({ data, handleSendForm, handleChangeFormPoll }) => {
    const base_url = useSelector((state: RootState) => state.api.image_api);
    return (
        <Box className="bg-[#FFF9F1] w-full min-h-[595px]">
            <Box sx={{ maxWidth: { sm: "100%", lg: "1240px", xl: "1440px" }, width: "100%", margin: "0 auto", py: 10 }}>
                <SwiperCustom data={data?.map((list) => {
                    const url_img = `${base_url}/${list?.media_file_path}/${list?.media_file_name}`;
                    const id_form_poll_choice_select = list?.form_poll_choice?.find((x: any) => x?.id_form_poll_choice_select)?.id_form_poll_choice_select;
                    const data_value = {
                        id_form_poll: list?.id_form_poll,
                        form_poll_choice: list?.form_poll_choice,
                        id_form_poll_choice: list?.id_form_poll_choice,
                        img_src: url_img,
                        auth_required: list?.auth_required ? true : false,
                        end_date: list?.form_poll_end,
                        group_name: list?.poll_type,
                        start_date: list?.form_poll_start,
                        title: list?.form_poll_name || "-",
                        total_vote: list?.total_vote || 0,
                        id_form_poll_choice_select: id_form_poll_choice_select
                    }
                    return {
                        content: <PollVoteCard handleChangeFormPoll={handleChangeFormPoll} onChange={(id_form_poll, id_form_poll_choice, auth_required) => {
                            handleSendForm?.(id_form_poll, id_form_poll_choice, auth_required)
                        }} data={[]} show_one={data_value} />
                    }
                })} />
            </Box>
        </Box>
    )
}


type commentWebsiteProps = {
    title: string;
    detail: string;
    data: any[];
}
export const CommentWebsite: React.FC<commentWebsiteProps> = ({ data, detail, title }) => {
    const base_url = useSelector((state: RootState) => state.api.image_api);
    return (
        <Box data-aos="fade-left"
            data-aos-anchor="#example-anchor"
            data-aos-offset="500"
            data-aos-duration="500" className="py-10 xl:py-[48px] h-full md:min-h-[540px] flex flex-col gap-4 w-full">
            <Typography textAlign={"center"} sx={{ color: "#4A4A4A", fontSize: 'clamp(2rem, 2.5vw, 36px)' }}>{title}</Typography>
            <Typography textAlign={"center"}>{detail}</Typography>
            <Box className="py-10">
                <SwiperCustom
                    slidesPerView={1}
                    classNameSlide="px-4 xl:px-1 cursor-grab"
                    breakpoints={{
                        1440: {
                            slidesPerView: 4,
                            spaceBetween: 10
                        },
                        1140: {
                            slidesPerView: 3,
                            spaceBetween: 10
                        },
                        720: {
                            slidesPerView: 2,
                            spaceBetween: 10
                        },
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10
                        },
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 10
                        }
                    }}
                    data={data?.map((list, i) => {
                        const url_img = list?.file_path ? `${base_url}${list?.file_path}/${list?.file_name}` : ""
                        return {
                            content: (
                                <Box
                                    sx={{
                                        boxShadow: [
                                            "0px 0px 5px 1px rgba(0,0,0,0.23)",
                                            "0px 0px 9px 1px rgba(0,0,0,.12)"
                                        ].join(", ")
                                    }} className="flex gap-4 my-6 p-4 md:p-[24px] rounded-[16px] min-h-[376px] max-h-[376px] w-full lg:max-w-[260px] xl:max-w-[340px] flex-col justify-between items-center" key={i}>
                                    <Box className="w-full justify-start flex-col flex gap-4 items-center">
                                        <Avatar
                                            sx={{
                                                width: 80,
                                                height: 80, objectFit: 'cover'
                                            }}
                                            src={list?.file_path ? url_img : undefined}
                                        />
                                        <Typography fontWeight={800} sx={{ color: '#9E640E', fontSize: "16px" }}>
                                            {list?.comment_name || "-"}
                                        </Typography>
                                        <Tooltip title={list?.comment_detail || ""} arrow>
                                            <Typography className="line-clamp-4 cursor-pointer">
                                                {`“${list?.comment_detail || ""}”`}
                                            </Typography>
                                        </Tooltip>
                                    </Box>
                                    <Box className="w-full flex gap-1 flex-col">
                                        <Box className="line-clamp-1" component={"span"} sx={{ color: "#828282", fontSize: { xs: "10px", md: "14px", } }} >หลักสูตร: </Box>
                                        <Box className="line-clamp-1" component={"span"} sx={{ color: "#828282", fontSize: { xs: "10px", md: "14px", } }} >{list?.comment_course || "-"}</Box>
                                        <Box className="line-clamp-1" component={"span"} sx={{ color: "#828282", fontSize: { xs: "10px", md: "14px", } }} >ตำแหน่งปัจจุบัน:</Box>
                                        <Box className="line-clamp-1" component={"span"} sx={{ color: "#828282", fontSize: { xs: "10px", md: "14px", } }} >{list?.comment_position || "-"}</Box>
                                    </Box>
                                </Box>
                            )
                        }
                    })}
                />
            </Box>

        </Box>
    )
}





type FacebookPageEmbedProps = {
    pageUrl: string;
    width?: number | string;
    height?: number | string;
};

export const FacebookPageEmbed: React.FC<FacebookPageEmbedProps> = ({
    pageUrl,
    width = 340,
    height = 500,
}) => {
    const src = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(
        pageUrl
    )}&tabs=timeline&width=${width}&height=${height}&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

    return (
        <iframe
            sandbox="allow-scripts allow-same-origin allow-popups"
            src={src}
            width={width}
            height={height}
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder={0}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        />
    );
};

type collaborationNetworkWebsiteProps = {
    title: string;
    detail: string;
    sub_detail: string;
    data: { id: number, img_url: string, link: string }[];
}
export const CollaborationNetworkWebsite: React.FC<collaborationNetworkWebsiteProps> = ({ data, detail, title, sub_detail }) => {
    return (
        <Box>
            <Typography textAlign={"center"} sx={{ color: "#4A4A4A" }} fontWeight={800} variant="h4">
                {title}
            </Typography>
            <Typography mt={1} textAlign={"center"} sx={{ color: "#828282", fontSize: "14px" }}>
                {detail}
            </Typography>
            <Typography textAlign={"center"} sx={{ color: "#828282", fontSize: "14px" }}>
                {sub_detail}
            </Typography>
            <Box className="mt-4 py-10 flex justify-start items-center gap-8 flex-wrap">
                {data?.map((list, i) => {
                    return <Box width={114} height={114}>
                        <Link to={list?.link} target="_blank">
                            <img className="w-full h-full object-cover" src={list?.img_url} alt={`img_${i + 1}`} />
                        </Link>
                    </Box>
                })}
            </Box>
        </Box>
    )
}